var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"emr-sync-button",attrs:{"variant":"primary"},on:{"click":_vm.update}},[_vm._v("\n    "+_vm._s(_vm.$translate(_vm.emrType))+"\n")])}
var staticRenderFns = []
export { render, staticRenderFns }